import { jsx } from "react/jsx-runtime";
import ErrorIcon from "@mui/icons-material/Error";
import { validateTidalLicense } from "../../base/index.js";
function Error(props) {
  return /* @__PURE__ */ jsx(
    ErrorIcon,
    {
      "data-testid": "Error",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Error",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Error.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Error"
};
validateTidalLicense();
export {
  Error
};
//# sourceMappingURL=Error.js.map
